module.exports = __webpack_public_path__ + "static/media/IMG_0336.b3cc1186.JPG";